const isValidMapboxClientKey = (key) => key?.includes('pk.ey');

export default isValidMapboxClientKey;
